/* eslint-disable @typescript-eslint/no-explicit-any */
import PostDetail from '@/components/BlogDetail'
import BlogList from '@/components/BlogList'
import Breadcrumb from '@/components/Breadcrumb'
import CategorySort from '@/components/Category/CategorySort'
import { ChildrenCategory } from '@/components/Category/ChildrenCategory'
import { FilterHighlight } from '@/components/Category/FilterHighlight'
import { FilterList } from '@/components/Category/FilterList'
import {
  FormAddress,
  FormButton,
  FormGroup,
  FormInput,
  FormText,
  FormTextRequire,
} from '@/components/Form'
import { AddToCartSuccess } from '@/components/Icon/AddToCartSuccess'
import { PopupClose } from '@/components/Icon/PopupClose'
import ImageOptimize from '@/components/ImageOptimize'
import { Loading } from '@/components/Loading/Loading'
import { LoadingIndicator } from '@/components/LoadingIndicator'
import PageBreadcrumb from '@/components/PageBreadcrumb'
import PopupBody from '@/components/Popup/PopupBody'
import PopupFrame from '@/components/Popup/PopupFrame'
import PopupTitle from '@/components/Popup/PopupTitle'
import ProductCard from '@/components/ProductCard'
import { Gallery } from '@/components/ProductDetail/Gallery'
import Information from '@/components/ProductDetail/Information'
import { RelatedProduct } from '@/components/ProductDetail/RelatedProduct'
import ReviewAndRate from '@/components/ProductDetail/ReviewAndRate'
import Specifications from '@/components/ProductDetail/Specifications'
import { BannerProductListing } from '@/components/ProductListing/BannerProductListing'
import ProductCardSkeleton from '@/components/Skeleton/ProductCardSkeleton'
import { BannerType, PageType, ServiceType } from '@/constants'
import { useAuth, useCart, useNotification, useStore } from '@/containers'
import { useAddressForm } from '@/hooks/useAddressForm'
import { useCategory } from '@/hooks/useCategoryHook'
import { Meta } from '@/layouts/Meta'
import { SelectedIcon } from '@/styles/Icon'
import { Main } from '@/templates/Main'
import type {
  BannerList,
  GiftItems,
  GuestInfo,
  OrderService,
  OtherOffers,
  Product,
  QueryParam,
} from '@/types'
import { type Property } from '@/types'
import { getTranslate, setContext } from '@/utils/api-interceptors'
import {
  getBannerSSR,
  getBottomMenu,
  getCategorySSR,
  getKeyword,
  getMenus,
  getPageDetailSSR,
  getPath,
  getQuickMenu,
  getSaleRegion,
} from '@/utils/endpoint'
import * as pixel from '@/utils/fpixel'
import { getPageTypeFromPath, stripHtmlTagsAndLimit } from '@/utils/next-util'
import { useIsomorphicLayoutEffect } from '@/utils/useIsomorphicLayoutEffect'
import { translateSchema } from '@/utils/validations'
import clsx from 'clsx'
import { getCookies } from 'cookies-next'
import { Form, Formik } from 'formik'
import orderBy from 'lodash/orderBy'
import { type GetServerSideProps, type GetServerSidePropsContext } from 'next'
import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useRef, useState } from 'react'
import { toast } from 'react-toastify'
import { v4 as uuidv4 } from 'uuid'
const PopupShare = dynamic(() => import('@/components/Popup/PopupShare'), {
  ssr: false,
})
const HomeBanner = dynamic(() => import('@/components/HomeBanner'), {
  ssr: false,
})
const EntrySummary = dynamic(
  () => import('@/components/ProductDetail/EntrySummary'),
  {
    ssr: false,
  }
)
interface DynamicPageProps {
  pageDetail: any
  categoryDetail: any
  banner: BannerList[]
  pageType: string
  hideMenu: string
}
const DynamicPage = ({
  pageDetail,
  categoryDetail,
  pageType,
  banner,
  hideMenu,
}: DynamicPageProps) => {
  const t = useTranslations('ProductDetail')
  const tCate = useTranslations('CategoryDetail')
  const [isOpenAddToCart, setIsOpenAddToCart] = useState(false)
  const [isOpenComingSoon, setIsOpenComingSoon] = useState(false)
  const [isOpenChooseDestination, setIsOpenChooseDestination] = useState(false)
  const [isOpenContact, setIsOpenContact] = useState(false)
  const [isOpenDraw, setIsOpenDraw] = useState(false)
  const [isOpenShare, setIsOpenShare] = useState(false)
  const { systemConfig } = useNotification()
  const {
    productCompares,
    setProductCompares,
    setIsOpenComparePopup,
    setProductViewed,
    setCatViewId,
    currentRegion,
  } = useStore()
  const addr = useAddressForm()

  const {
    addToCart,
    cartLoading,
    chooseDestination,
    setGuestInfo,
    guestInfo,
    isPreOrder,
    setIsPreOrder,
    sendContact,
    addBundleToCart,
  } = useCart()

  const [listService, setListService] = useState<OrderService[]>([])
  const [pickUpInStore, setPickUpInStore] = useState(false)
  const [isBuyNowWithBundleProduct, setIsBuyNowWithBundleProduct] =
    useState(false)
  const [listGift, setListGift] = useState<GiftItems[] | undefined>([])
  const [listOffer, setListOffer] = useState<OtherOffers[] | undefined>([])
  const [priceWithService, setPriceWithService] = useState(0)
  const [checkSaleArea] = useState(true)

  const [listBundleSelected, setListBundleSelected] = useState<Product[]>([])
  const specRef = useRef<HTMLDivElement>(null)
  const reviewRef = useRef<HTMLDivElement>(null)
  const descRef = useRef<HTMLDivElement>(null)
  const {
    channel,
    setDestinationCode,
    user,
    storeList,
    storeSelected,
    setStoreSelected,
    globalLoading,
  } = useAuth()
  const {
    loading,
    setLoading,
    products,
    properties,
    highLightProperties,
    updateParams,
    activeFilters,
    currentPage,
    setCurrentPage,
    totalProduct,
    getProducts,
    setProducts,
    totalPages,
    sortByOptions,
    activeSort,
    activeSortCustom,
  } = useCategory(categoryDetail, pageDetail)
  const router = useRouter()
  const defaultReviewSummary = [0, 0, 0, 0, 0]
  useEffect(() => {
    return () => {
      setProducts([])
      setCurrentPage(1)
    }
  }, [])

  useEffect(() => {
    return () => {
      setCurrentPage(1)
    }
  }, [categoryDetail, router])

  useEffect(() => {
    if (pageDetail && pageDetail.data && pageType === PageType.PRODUCT) {
      const newListService = pageDetail.data.orderServices
        ?.sort((a: any, b: any) => a?.order - b?.order)
        ?.map((e: any) => {
          if (e) {
            return { ...e, active: false }
          }
          return null
        })
        ?.filter(Boolean)
      setListService(newListService)
    }
  }, [pageDetail, pageType, channel])
  useEffect(() => {
    setListBundleSelected([])
  }, [])
  useEffect(() => {
    if (isOpenChooseDestination || isOpenContact) {
      addr.loadProvinces('old')
    }
    if (isOpenChooseDestination && (user || guestInfo)) {
      const pCode = user?.provinceCode || guestInfo?.provinceCode
      if (pCode) {
        addr.loadWardDistricts(pCode as string)
      }
    }
  }, [isOpenChooseDestination, isOpenContact, user, guestInfo])

  useEffect(() => {
    if (pageDetail && pageType === PageType.PRODUCT) {
      const mergeData = pageDetail?.data?.gifts?.reduce(
        (result: any, item: any) => {
          result.otherOffers = (result.otherOffers || []).concat(
            item.otherOffers
          )
          result.giftItems = (result.giftItems || []).concat(item.giftItems)
          return result
        },
        {} as any
      )
      const gifts = mergeData?.giftItems?.map((e: any) => {
        if (e.optionBuy) {
          e.checked = false
        }
        return { ...e, active: true }
      })
      return setListGift(gifts)
    }
  }, [pageDetail, pageType, channel])
  useEffect(() => {
    if (pageDetail && pageType === PageType.PRODUCT) {
      setCatViewId(pageDetail?.data?.catId)
      setProductViewed(
        pageDetail?.data?.relatedProductIds.map((e: any) => ({
          _id: e,
        }))
      )
      const mergeData = pageDetail?.data?.gifts?.reduce(
        (result: any, item: any) => {
          result.otherOffers = (result.otherOffers || []).concat(
            item.otherOffers
          )
          return result
        },
        {} as any
      )
      const offer = mergeData?.otherOffers?.map((e: any) => {
        return { content: e, active: true }
      })
      if (
        pageDetail?.data?.gifts?.filter(
          (item: { otherOffers: any }) => item.otherOffers
        ).length > 0
      ) {
        return setListOffer(offer)
      }
    }
  }, [pageDetail, pageType, channel])
  useEffect(() => {
    pixel.fbqEvent('ViewContent', {
      content_name: getTranslate(pageDetail?.data?.name),
      content_type: 'product',
    })
    return () => {
      setIsOpenComparePopup(false)
    }
  }, [pageDetail])
  const productName = useMemo(() => {
    return getTranslate(pageDetail?.data?.name)
  }, [pageDetail])

  const productDescription = useMemo(() => {
    return stripHtmlTagsAndLimit(
      getTranslate(pageDetail?.data?.description),
      160
    )
  }, [pageDetail])
  const pageShortDescription = useMemo(() => {
    return stripHtmlTagsAndLimit(
      getTranslate(pageDetail?.data?.shortDescription),
      160
    )
  }, [pageDetail])
  const middleBanner = useMemo(() => {
    return banner.filter(banner => {
      return banner.type === BannerType.HOME && banner.status === 1
    })
  }, [banner])
  const reviewSummaryData = useMemo(() => {
    if (pageDetail?.data?.reviewSummary) {
      return pageDetail?.data?.reviewSummary
    }
    return defaultReviewSummary
  }, [pageDetail?.data])
  const fetchMoreProducts = () => {
    setCurrentPage(currentPage + 1)
    setLoading(true)
    getProducts(
      {
        limit: 40,
        categoryDefault: categoryDetail._id,
        currentPage: currentPage + 1,
        sortBy: 'catOrder',
        sortType: 'asc',
        catDisplay: true,
        ...router.query,
      },
      {
        onSuccess: res => {
          setProducts(products.concat(res.data.data))
          setLoading(false)
        },
        onError: () => {
          setLoading(false)
        },
      }
    )
  }
  const executeScroll = (ref: {
    current: {
      scrollIntoView: (arg0: {
        behavior: string
        block: string
        inline: string
      }) => void
    }
  }) => {
    ref?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'start',
    })
  }
  const targetRef = useRef<HTMLDivElement>(null)
  const [isReadMore, setIsReadMore] = useState(false)
  const [dimensions, setDimensions] = useState(0)
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }
  useIsomorphicLayoutEffect(() => {
    let timeout: NodeJS.Timeout | null = null
    const measureHeight = () => {
      if (targetRef && targetRef.current && categoryDetail?.content) {
        setDimensions(targetRef.current.clientHeight)
      }
    }
    timeout = setTimeout(measureHeight, 400)
    return () => {
      setDimensions(0)
      setIsReadMore(false)
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [categoryDetail?.content])
  useEffect(() => {
    if (pageDetail?.data?.preOrder && pageType == PageType.PRODUCT) {
      return setIsPreOrder(true)
    }
    return setIsPreOrder(false)
  }, [pageDetail, pageType])
  const imageGallery = pageDetail?.data?.videoUrl
    ? [
        pageDetail?.data?.videoThumbnail || '',
        ...(pageDetail?.data?.images || []),
      ]
    : pageDetail?.data?.images || []
  if (pageDetail && pageType === PageType.PRODUCT) {
    return (
      <Main
        meta={
          <Meta
            title={
              getTranslate(pageDetail?.data?.metaTitle) &&
              getTranslate(pageDetail?.data?.metaTitle) !== ''
                ? getTranslate(pageDetail?.data?.metaTitle)
                : getTranslate(pageDetail?.data?.title)
            }
            description={
              getTranslate(pageDetail?.data?.metaDescription) &&
              getTranslate(pageDetail?.data?.metaDescription) !== ''
                ? getTranslate(pageDetail?.data?.metaDescription)
                : pageShortDescription || productDescription || ''
            }
            noIndex={pageDetail?.data?.noIndex}
            noFollow={pageDetail?.data?.noFollow}
            keywords={getTranslate(pageDetail?.data?.keywords) || []}
            imageUrl={pageDetail?.data?.thumbnail}
            canonical={
              pageDetail?.data?.canonicalUrl ||
              process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath
            }
            mobileAlternate={{
              media: 'only screen and (max-width:991px))',
              href:
                process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
                process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
                '',
            }}
          />
        }
        page='product-detail'
      >
        <div className='wrapper'>
          <Breadcrumb translateText={t('Homepage')} data={pageDetail?.data} />
          <section className='product_summary my-4 grid grid-cols-12 gap-4'>
            <div className='col-span-7'>
              <Gallery
                images={imageGallery}
                alt={productName}
                label={pageDetail?.data}
                product={pageDetail?.data}
                refs={{ specRef, reviewRef, descRef }}
                handleClickRef={executeScroll}
              />
              <div
                id='description'
                ref={descRef}
                className='w-full scroll-mt-[120px]'
              >
                <Information
                  title={t('information')}
                  description={pageDetail?.data?.description}
                />
              </div>
            </div>
            <div className='col-span-5'>
              <div className='rounded-lg bg-white px-[20px] py-4'>
                <EntrySummary
                  setIsOpenAddToCart={setIsOpenAddToCart}
                  setIsOpenContact={setIsOpenContact}
                  setIsOpenComingSoon={setIsOpenComingSoon}
                  setIsOpenChooseDestination={setIsOpenChooseDestination}
                  setIsOpenComparePopup={setIsOpenComparePopup}
                  setIsOpenDraw={setIsOpenDraw}
                  setIsOpenShare={setIsOpenShare}
                  handleAddToCart={addToCart}
                  entrySummaryData={pageDetail?.data}
                  cartLoading={cartLoading}
                  checkSaleArea={checkSaleArea}
                  setListService={setListService}
                  listService={listService}
                  setListGift={setListGift}
                  listGift={listGift}
                  setListOffer={setListOffer}
                  listOffer={listOffer}
                  productCompares={productCompares}
                  setProductCompares={setProductCompares}
                  pickUpInStore={pickUpInStore}
                  setPickUpInStore={setPickUpInStore}
                  isPreOrder={isPreOrder}
                  listBundleSelected={listBundleSelected}
                  handleAddBundleToCart={addBundleToCart}
                  setIsBuyNowWithBundleProduct={setIsBuyNowWithBundleProduct}
                  isBuyNowWithBundleProduct={isBuyNowWithBundleProduct}
                  priceWithService={priceWithService}
                  setPriceWithService={setPriceWithService}
                  polices={pageDetail?.data?.properties}
                  outstandingFeatures={pageDetail?.data?.outstandingFeatures}
                  label={pageDetail?.data}
                />
                <div
                  id='spec'
                  ref={specRef}
                  className='w-full scroll-mt-[120px]'
                >
                  <Specifications
                    specificationTitle={t('specification')}
                    specifications={pageDetail?.data?.properties?.filter(
                      (item: any) => !item.policy
                    )}
                  />
                </div>
                {pageDetail?.data?.document && (
                  <div className='document mt-4'>
                    <div className='flex'>
                      <div className='label w-full max-w-[45%] flex-[45%] pr-3 text-base font-medium'>
                        Hướng dẫn sử dụng
                      </div>
                      <div className='max-w-[55%] flex-[55%]'>
                        <Link
                          href={pageDetail?.data?.document}
                          className='value text-base text-primary-base'
                        >
                          Xem hướng dẫn
                        </Link>
                      </div>
                    </div>
                  </div>
                )}

                <div
                  id='review'
                  ref={reviewRef}
                  className='w-full scroll-mt-[120px]'
                >
                  <ReviewAndRate
                    title={getTranslate(pageDetail?.data?.name)}
                    productId={pageDetail?.data?._id}
                    average={pageDetail?.data?.average}
                    reviewSummary={reviewSummaryData}
                  />
                </div>
              </div>
            </div>
            <div className='product_summary_inner grid grid-cols-2 gap-x-6'></div>
          </section>
          <section className='info-pdp mb-10 flex w-full justify-between'>
            <RelatedProduct
              relatedProductTitle={t('relatedProduct')}
              relatedProductData={orderBy(
                pageDetail?.data?.relatedProducts,
                'order',
                'asc'
              )}
            />
          </section>

          <BlogList
            title={t('blogListTitle')}
            subTitle={t('blogListSubTitle')}
          />
          <HomeBanner
            banner={middleBanner[1]?.items}
            layout={middleBanner[1]?.layout}
          />
        </div>

        {/* Popup add to cart */}
        <PopupFrame
          open={isOpenAddToCart}
          onClose={() => {
            setIsOpenAddToCart(false)
          }}
          closeText={t('close')}
          className='min-h-[361px] w-[480px] max-w-[520px] bg-white'
        >
          <PopupTitle className='h-[48px] border-b border-dark-200'>
            {
              <div
                onClick={() => setIsOpenAddToCart(false)}
                className='absolute right-[12px] top-[40%] flex translate-y-[-40%] cursor-pointer items-center gap-1'
              >
                <PopupClose className='text-dark-400' />
                {t('close')}
              </div>
            }
          </PopupTitle>
          <PopupBody>
            <div className='listLocation mt-[18px] flex h-full max-h-[300px] flex-col items-center justify-center gap-y-[12px] overflow-scroll border-dark-100 px-[24px] scrollbar-hide'>
              <AddToCartSuccess />
              <h3 className='text-HeadlineMedium mt-[26px] font-bold text-dark-400'>
                {t('notifi')}
              </h3>
              <p className='mt-[8px] text-Headline text-dark-400'>
                {t('addedToCart')}
              </p>
              <FormButton
                onClick={() => {
                  setIsOpenAddToCart(false)
                  router.push('/checkout/cart')
                }}
                className={clsx(
                  'disabled:text-[rgb(0 0 0 / 25%)] mt-[32px] h-[40px] w-[200px] rounded border bg-primary-second text-fieldInput font-bold text-white disabled:outline-none'
                )}
              >
                {t('viewCart')}
              </FormButton>
            </div>
          </PopupBody>
        </PopupFrame>

        {/* Popup choose destination */}
        <PopupFrame
          open={isOpenChooseDestination}
          onClose={() => {
            setIsOpenChooseDestination(false)
          }}
          closeText={t('close')}
          type='selectDestination'
          className='min-h-[360px] min-w-[520px] !overflow-visible bg-white'
        >
          <PopupTitle className='bg-white px-4 pt-3' type={'selectDestination'}>
            {
              <div className='flex justify-between'>
                <p className='w-[70%] text-Headline font-bold text-dark-400'>
                  {t('selectDestination')}
                </p>
                <div
                  onClick={() => setIsOpenChooseDestination(false)}
                  className='absolute right-[12px] top-[50%] flex translate-y-[-40%] cursor-pointer items-center gap-1'
                >
                  <PopupClose className='text-dark-400' />
                  {t('close')}
                </div>
              </div>
            }
          </PopupTitle>
          <PopupBody>
            <div className='listLocation mt-[18px] h-full !max-h-[300px] rounded px-[20px]'>
              <Formik
                initialValues={{
                  wardCode: guestInfo?.wardCode || '',
                  provinceCode: guestInfo?.provinceCode || '',
                }}
                validationSchema={translateSchema('chooseDestination', t)}
                onSubmit={values => {
                  chooseDestination(values.wardCode, pageDetail?.data._id).then(
                    res => {
                      const districtCode = addr.wardDistricts.find(
                        f => f.code === values.wardCode
                      )?.parentCode as string
                      setIsOpenChooseDestination(false)
                      setGuestInfo({
                        ...guestInfo,
                        wardCode: values.wardCode,
                        districtCode,
                        provinceCode: values.provinceCode,
                        saleRegionCode: currentRegion,
                      } as GuestInfo)
                      setDestinationCode(values.wardCode as string)
                      setListService(
                        listService.map(e => {
                          if (e.type === ServiceType.SHIPPING) {
                            e.price = res
                          }
                          return e
                        })
                      )
                    }
                  )
                }}
              >
                {props => (
                  <Form onSubmit={props.handleSubmit}>
                    <div className=''>
                      <span className=''>{t('provincePld')}</span>
                      <FormAddress
                        className='mt-[5px] rounded'
                        classSelectButtonName='rounded'
                        onChange={e => {
                          addr.loadWardDistricts(e.target.value)
                          props.setFieldValue('provinceCode', e.target.value)
                          props.setFieldValue('wardCode', '')
                        }}
                        value={props.values.provinceCode}
                        placeholder={t('provincePld')}
                        name='provinceCode'
                        classNarrow='!px-2'
                        placeholderColor='text-dark-400/70'
                        data={addr.provinces}
                      />
                      {props.errors.provinceCode ? (
                        <FormTextRequire className='text-base font-normal text-primary-second'>
                          {props.errors.provinceCode as string}
                        </FormTextRequire>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className='mt-[25px]'>
                      <span className=''>Chọn Quận/Huyện - Phường/Xã</span>
                      <FormAddress
                        className='mt-[5px] rounded'
                        classSelectButtonName='rounded'
                        onChange={e => {
                          props.setFieldValue(
                            'wardCode',
                            e.target.value || guestInfo?.wardCode
                          )
                        }}
                        value={props.values.wardCode}
                        placeholder='Chọn Quận/Huyện - Phường/Xã'
                        name='wardCode'
                        classNarrow='!px-2'
                        placeholderColor='text-dark-400/70'
                        data={addr.wardDistricts}
                      />
                      {props.errors.wardCode ? (
                        <FormTextRequire className='text-base font-normal text-primary-second'>
                          {props.errors.wardCode as string}
                        </FormTextRequire>
                      ) : (
                        ''
                      )}
                    </div>
                    <FormButton
                      className={clsx(
                        'disabled:text-[rgb(0 0 0 / 25%)] mt-[32px] h-[40px] w-full rounded border bg-primary-second text-fieldInput font-bold text-white disabled:outline-none'
                      )}
                    >
                      {cartLoading ? <Loading /> : t('confirm')}
                    </FormButton>
                  </Form>
                )}
              </Formik>
            </div>
          </PopupBody>
        </PopupFrame>

        {/* Popup contact */}
        <PopupFrame
          open={isOpenContact}
          onClose={() => {
            setIsOpenContact(false)
          }}
          closeText={t('close')}
          type='selectDestination'
          className='min-h-[420px] w-[600px] !overflow-visible bg-white'
        >
          <PopupTitle
            className='border-b border-zinc-300 px-3 pt-3'
            type={'selectDestination'}
          >
            <div className='relative flex w-full flex-wrap items-center'>
              <p className='w-[70%] text-lg font-bold'>Gọi lại cho tôi</p>
              <div
                onClick={() => setIsOpenContact(false)}
                className='absolute right-0 top-[50%] z-10 flex translate-y-[-50%] cursor-pointer items-center gap-1'
              >
                <PopupClose className=' text-dark-400' />
              </div>
            </div>
          </PopupTitle>
          <PopupBody>
            <div className='listLocation mt-[18px] h-full rounded px-[20px]'>
              <Formik
                initialValues={{
                  phone: '',
                  name: '',
                  provinceCode: '',
                }}
                validationSchema={translateSchema('contact', t)}
                onSubmit={async values => {
                  await sendContact({
                    ...values,
                    productIds: [pageDetail?.data?._id],
                  }).then(() => {
                    toast.success('Gửi yêu cầu thành công', {
                      position: 'top-center',
                      autoClose: 3000,
                      hideProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: false,
                      draggable: true,
                      progress: undefined,
                      theme: 'light',
                    })
                  })
                  setIsOpenContact(false)
                  return
                }}
              >
                {props => (
                  <Form onSubmit={props.handleSubmit}>
                    <span className='text-Headline italic text-dark-400'>
                      Vui lòng nhập các thông tin phía dưới để{' '}
                      {systemConfig?.websiteBrandName} có thể liên hệ, tư vấn
                      cho quý khách hàng một cách nhanh và thuận lợi nhất.
                    </span>
                    <div className='mt-3'>
                      <FormGroup className='mb-2 flex flex-500 flex-col'>
                        <FormText className='mb-1 text-left text-base font-semibold'>
                          Họ và tên
                        </FormText>
                        <FormInput
                          name='name'
                          onChange={props.handleChange}
                          placeholder={'Nhập họ và tên'}
                          value={props.values.name}
                        />
                        {props.errors.name ? (
                          <FormTextRequire className='text-base font-normal text-primary-second'>
                            {props.errors.name as string}
                          </FormTextRequire>
                        ) : (
                          ''
                        )}
                      </FormGroup>
                      <FormGroup className='mb-2 flex flex-500 flex-col'>
                        <FormText className='mb-1 text-left text-base font-semibold'>
                          Số điện thoại
                        </FormText>
                        <FormInput
                          name='phone'
                          placeholder={'Nhập số điện thoại'}
                          value={props.values.phone}
                          onChange={props.handleChange}
                        />
                        {props.errors.phone && (
                          <FormTextRequire className='text-fieldInput text-sm font-normal text-primary-second'>
                            {props.errors.phone as string}
                          </FormTextRequire>
                        )}
                      </FormGroup>
                      <FormGroup className='mb-2 flex flex-500 flex-col'>
                        <FormText className='mb-1 text-left text-base font-semibold'>
                          Tỉnh/thành
                        </FormText>
                        <FormAddress
                          onChange={e => {
                            props.handleChange({
                              target: {
                                value: e.target.value,
                                name: 'provinceCode',
                              },
                            })
                          }}
                          value={props.values.provinceCode}
                          placeholder={t('provincePld')}
                          name='provinceCode'
                          className='bg-white'
                          placeholderColor='text-dark-400/70'
                          isError={props.errors.provinceCode}
                          data={addr.provinces}
                        />
                        {props.errors.provinceCode ? (
                          <FormTextRequire className='text-fieldInput text-sm font-normal text-primary-second'>
                            {props.errors.provinceCode as string}
                          </FormTextRequire>
                        ) : (
                          ''
                        )}
                      </FormGroup>
                      <FormButton
                        className={clsx(
                          'disabled:text-[rgb(0 0 0 / 25%)] relative bottom-[20px] mt-[32px] h-12 w-full rounded border border-primary-second bg-primary-second text-fieldInput font-bold uppercase text-white disabled:outline-none'
                        )}
                      >
                        {cartLoading ? <Loading /> : t('confirm')}
                      </FormButton>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </PopupBody>
        </PopupFrame>
        {/* Popup choose store */}
        <PopupFrame
          open={isOpenDraw}
          onClose={() => {
            setIsOpenDraw(false)
          }}
          closeText={t('close')}
          type='selectDestination'
          className='min-h-[360px] min-w-[550px] max-w-[600px] !rounded-sm bg-white'
        >
          <PopupTitle className='bg-white px-4 pt-3' type={'selectDestination'}>
            {
              <div className='flex justify-between'>
                <p className='w-[70%] text-Headline font-bold text-dark-400'>
                  {t('selectDestination')}
                </p>
                <div
                  onClick={() => setIsOpenDraw(false)}
                  className='absolute right-[12px] top-[50%] flex translate-y-[-40%] cursor-pointer items-center gap-1'
                >
                  <PopupClose className='text-dark-400' />
                  {t('close')}
                </div>
              </div>
            }
          </PopupTitle>
          <PopupBody>
            <div className='listLocation mx-3 mb-10 mt-[18px] flex h-full max-h-[530px] flex-row flex-wrap gap-3 overflow-y-auto px-1'>
              {globalLoading ? (
                <LoadingIndicator />
              ) : (
                storeList &&
                storeList.map((item, index) => (
                  <div
                    key={index}
                    className={`${
                      storeSelected?._id === item._id && 'border-orange'
                    } box-content block min-h-[58px] w-full overflow-hidden rounded border-[1px] border-dark px-3 pt-1 outline-none `}
                    onClick={() => {
                      setStoreSelected(item)
                      setIsOpenDraw(false)
                    }}
                  >
                    <div className='flex flex-wrap items-start'>
                      <span
                        className={`mt-[4px] w-[30px] max-w-[30px] flex-[30px]`}
                      >
                        {storeSelected?._id === item._id ? (
                          <SelectedIcon />
                        ) : (
                          <span className='block h-[18px] w-[18px] overflow-hidden rounded-[100%] border border-dark-700'></span>
                        )}
                      </span>
                      <div className='flex max-w-[calc(100%-30px)] flex-[calc(100%-30px)] flex-row flex-wrap items-start justify-start gap-[2px] text-left'>
                        <p className={'block w-full text-base font-bold'}>
                          {getTranslate(item.name)}
                        </p>
                        <p className='block w-full text-base text-dark-500'>
                          {item.fullAddress}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </PopupBody>
        </PopupFrame>

        {/* Popup comming soon */}
        <PopupFrame
          closeText={t('close')}
          open={isOpenComingSoon}
          onClose={() => {
            setIsOpenComingSoon(false)
          }}
          className='min-h-[581px] w-[528px] max-w-[528px] bg-white'
        >
          <PopupTitle className='h-[48px] border-b border-dark-200'>
            {
              <div
                onClick={() => setIsOpenComingSoon(false)}
                className='absolute right-[12px] top-[40%] flex translate-y-[-40%] cursor-pointer items-center gap-1'
              >
                <PopupClose className='text-dark-400' />
                {t('close')}
              </div>
            }
          </PopupTitle>
          <PopupBody>
            <div className='listLocation flex h-full flex-col items-center justify-center overflow-scroll border-dark-100 px-[24px] scrollbar-hide'>
              <ImageOptimize
                src={'/commingsoon.svg'}
                alt='Coming soon'
                width={306}
                height={300}
                className='mt-[32px] object-cover'
              />
              <h3 className='text-HeadlineMedium mt-[24px] font-bold text-dark-400'>
                {t('commingSoon')}
              </h3>
              <p className='mt-[8px] w-[373px] text-center text-Headline text-dark-400'>
                {t('commingSoonDesc')}
              </p>
              <FormButton
                onClick={() => {
                  setIsOpenComingSoon(false)
                }}
                className={clsx(
                  'disabled:text-[rgb(0 0 0 / 25%)] mt-2 h-[40px] w-[200px] rounded border bg-primary-second text-fieldInput font-bold text-white disabled:outline-none'
                )}
              >
                {t('understood')}
              </FormButton>
            </div>
          </PopupBody>
        </PopupFrame>
        {/* Popup comming soon */}
        <PopupShare
          setIsOpenShare={setIsOpenShare}
          isOpenShare={isOpenShare}
          data={pageDetail?.data}
        />
      </Main>
    )
  }
  if (pageDetail && pageType === PageType.PAGE_CMS) {
    const breadcrumbs = [
      { label: getTranslate(pageDetail?.data.title) || '', href: '/' },
    ]
    return (
      <Main
        meta={
          <Meta
            title={
              getTranslate(pageDetail?.data?.metaTitle) &&
              getTranslate(pageDetail?.data?.metaTitle) !== ''
                ? getTranslate(pageDetail?.data?.metaTitle)
                : getTranslate(pageDetail?.data?.title)
            }
            description={
              getTranslate(pageDetail?.data?.metaDescription) &&
              getTranslate(pageDetail?.data?.metaDescription) !== ''
                ? getTranslate(pageDetail?.data?.metaDescription)
                : getTranslate(pageDetail?.data?.description)
            }
            noIndex={pageDetail?.data?.noIndex}
            noFollow={pageDetail?.data?.noFollow}
            keywords={getTranslate(pageDetail?.data?.keywords) || []}
            imageUrl={pageDetail?.data?.thumbnail}
            canonical={
              pageDetail?.data?.canonicalUrl ||
              process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath
            }
            mobileAlternate={{
              media: 'only screen and (max-width:991px))',
              href:
                process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
                process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
                '',
            }}
          />
        }
      >
        <section className='min-h-[500px] pb-[120px]'>
          <PageBreadcrumb
            homeText={t('Homepage')}
            className='mb-3'
            breadcrumbs={breadcrumbs}
          />
          <h1 className='mb-[32px] text-titleSection font-bold'>
            {getTranslate(pageDetail?.data.title)}{' '}
          </h1>
          <div
            dangerouslySetInnerHTML={{
              __html: getTranslate(pageDetail?.data.content),
            }}
          ></div>
        </section>
      </Main>
    )
  }
  if (pageDetail && pageType === PageType.POST) {
    return <PostDetail postDetail={pageDetail?.data} hideMenu={hideMenu} />
  }
  if (categoryDetail) {
    return (
      <Main
        meta={
          <Meta
            title={
              getTranslate(categoryDetail?.metaTitle) &&
              getTranslate(categoryDetail?.metaTitle) !== ''
                ? getTranslate(categoryDetail?.metaTitle)
                : getTranslate(categoryDetail?.name)
            }
            description={
              getTranslate(categoryDetail?.metaDescription) &&
              getTranslate(categoryDetail?.metaDescription) !== ''
                ? getTranslate(categoryDetail?.metaDescription)
                : getTranslate(categoryDetail?.description)
            }
            noFollow={categoryDetail?.noFollow}
            noIndex={categoryDetail?.noIndex}
            canonical={
              categoryDetail?.canonicalUrl ||
              process.env.NEXT_PUBLIC_URL_WEBSITE + router.asPath
            }
            imageUrl={categoryDetail.image}
            imageAlt={getTranslate(categoryDetail.name)}
            mobileAlternate={{
              media: 'only screen and (max-width:991px))',
              href:
                process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE + router.asPath ||
                process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE ||
                '',
            }}
          />
        }
      >
        {categoryDetail?.productCatBanners && (
          <BannerProductListing data={categoryDetail.productCatBanners} />
        )}
        {categoryDetail && categoryDetail?.children?.length > 0 && (
          <ChildrenCategory data={categoryDetail?.children} />
        )}
        <section className='topFilters'>
          {!categoryDetail?.children ||
          categoryDetail?.children?.length == 0 ? (
            <>
              <div className='mb-3 text-base font-bold text-dark-800'>
                Tìm kiếm sản phẩm
              </div>

              <FilterList
                properties={properties}
                activeFilters={activeFilters}
                onChange={updateParams}
              />
            </>
          ) : (
            ''
          )}
          {highLightProperties &&
            highLightProperties.map((e: Property) => (
              <FilterHighlight
                key={`e-${e._id}`}
                filterGroup={e}
                activeFilters={activeFilters}
                onChange={updateParams}
              />
            ))}
        </section>
        <section className='cateMainContent flex h-auto w-full gap-5 pb-[30px]'>
          <div className='cateProductList w-full' id='scrollableDiv'>
            <div className='gap mt-2 flex items-center gap-3 text-base text-dark-400'>
              <h1>
                <strong> {totalProduct}</strong>{' '}
                {getTranslate(categoryDetail.name)}
              </h1>
              <CategorySort
                sortOptions={sortByOptions}
                onChange={updateParams}
                activeSort={activeSort}
                activeSortCustom={activeSortCustom}
              />
            </div>
            {loading && (
              <div className='products mt-[30px] grid grid-cols-5 gap-[20px]'>
                {[...new Array(12)].map(() => (
                  <ProductCardSkeleton key={uuidv4()} />
                ))}
              </div>
            )}
            {products && products.length > 0 ? (
              <>
                <div className='products mt-[30px] grid grid-cols-5 gap-[20px]'>
                  {products.map((product, idx) => (
                    <ProductCard
                      layout={3}
                      product={product}
                      key={product._id + idx + 'list'}
                      type='list'
                    />
                  ))}
                </div>
                {currentPage < totalPages && (
                  <div
                    className='loadMore relative mx-auto mt-6 flex w-max min-w-[160px] cursor-pointer items-center justify-center gap-2 rounded-lg  bg-dark-900 px-4 py-2'
                    onClick={fetchMoreProducts}
                  >
                    {loading ? (
                      <Loading />
                    ) : (
                      <span className=' text-center text-base font-medium leading-normal text-white'>
                        Xem thêm
                      </span>
                    )}
                  </div>
                )}
              </>
            ) : (
              ''
            )}
            {products && products.length == 0 && !loading && (
              <div className='mt-[44px] flex flex-col items-center justify-center'>
                <ImageOptimize
                  src='/no-product.svg'
                  alt='Không tìm thấy sản phẩm phù hợp'
                  width={500}
                  height={372}
                />
                <span className='text-HeadlineMedium mt-[20px] font-normal'>
                  {tCate('notFound')}
                </span>
              </div>
            )}
          </div>
        </section>
        <section
          className={`contentCategory relative mb-[100px] flex flex-wrap`}
        >
          <div
            className={`content flex flex-col items-start overflow-hidden transition-height  duration-500 ease-in-out ${
              isReadMore ? 'max-h-full' : 'max-h-[125px]'
            }`}
          >
            <div
              ref={targetRef}
              dangerouslySetInnerHTML={{
                __html: getTranslate(categoryDetail?.content),
              }}
            />
          </div>
          {dimensions < 125 ? (
            ''
          ) : (
            <div
              className={`absolute -bottom-6 left-0 z-50 flex h-[173px] w-full items-end ${
                isReadMore ? '' : 'bg-gradient-to-b from-white/0 to-white'
              }`}
            >
              <button
                className='readMore z-50 mx-auto mb-0 mt-auto flex w-[120px] cursor-pointer flex-col flex-wrap items-center justify-center px-3 pt-3'
                type='button'
                onClick={toggleReadMore}
              >
                <span className='rot text-center text-base font-normal leading-normal text-primary-base'>
                  {isReadMore ? 'Thu gọn' : 'Xem thêm'}{' '}
                </span>
                <span className={`${isReadMore ? 'rotate-180' : ''}`}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width={18}
                    height={19}
                    viewBox='0 0 18 19'
                    fill='none'
                  >
                    <path
                      d='M8.99999 14.2383C8.8522 14.2385 8.70584 14.2094 8.56932 14.1529C8.43279 14.0963 8.30879 14.0133 8.20444 13.9087L1.45444 7.15867C1.24606 6.94715 1.12974 6.66181 1.13087 6.36489C1.13199 6.06796 1.25046 5.78352 1.46043 5.57358C1.67041 5.36363 1.95488 5.24522 2.25181 5.24415C2.54873 5.24308 2.83404 5.35944 3.04553 5.56786L8.99999 11.5222L14.9544 5.56786C15.1659 5.35944 15.4512 5.24308 15.7482 5.24415C16.0451 5.24522 16.3296 5.36363 16.5395 5.57358C16.7495 5.78352 16.868 6.06796 16.8691 6.36489C16.8702 6.66181 16.7539 6.94715 16.5455 7.15867L9.79553 13.9087C9.69118 14.0133 9.56718 14.0963 9.43066 14.1529C9.29413 14.2094 9.14777 14.2385 8.99999 14.2383Z'
                      fill='#00C1D5'
                      fillOpacity='0.8'
                    />
                    <path
                      d='M8.99999 8.89452C8.8522 8.89471 8.70584 8.86569 8.56932 8.80912C8.43279 8.75256 8.30879 8.66957 8.20444 8.56492L2.86069 3.22117C2.65231 3.00965 2.53599 2.72432 2.53712 2.42739C2.53824 2.13046 2.65671 1.84602 2.86668 1.63608C3.07666 1.42613 3.36113 1.30772 3.65806 1.30665C3.95498 1.30558 4.24029 1.42194 4.45178 1.63036L8.99999 6.17843L13.5482 1.63036C13.7597 1.42194 14.045 1.30558 14.3419 1.30665C14.6388 1.30772 14.9233 1.42613 15.1333 1.63608C15.3433 1.84602 15.4617 2.13046 15.4629 2.42739C15.464 2.72432 15.3477 3.00965 15.1393 3.22117L9.79553 8.56492C9.69119 8.66957 9.56718 8.75256 9.43066 8.80912C9.29413 8.86569 9.14777 8.89471 8.99999 8.89452Z'
                      fill='#00C1D5'
                      fillOpacity='0.8'
                    />
                  </svg>
                </span>
              </button>
            </div>
          )}
        </section>
        <BlogList title={t('blogListTitle')} subTitle={t('blogListSubTitle')} />
        <HomeBanner
          banner={middleBanner[1]?.items}
          layout={middleBanner[1]?.layout}
        />
      </Main>
    )
  }
}
export default DynamicPage
export const getServerSideProps: GetServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { req, res, query } = context
  const { token, language, messages } = await setContext(
    getCookies({ req, res }),
    {
      language: context.locale,
    }
  )
  let categoryDetail
  const { slug, hideMenu } = query
  if (!slug) {
    return {
      notFound: true,
    }
  }
  const path = slug[slug.length - 1].split('.')
  if (path.length > 1 && path[1].indexOf('c') > -1) {
    categoryDetail = await getCategorySSR(path[0], query as QueryParam)
    if (!categoryDetail) {
      return {
        notFound: true,
      }
    }
  } else {
    const pathMapping =
      Array.isArray(slug) && slug.length > 1 ? slug.join('/') : slug
    const path = await getPath(pathMapping as string)
    if (path) {
      return {
        redirect: {
          permanent: true,
          source: `/${path.path}`,
          destination: `/${path.slug || path.url}`,
        },
      }
    }
  }
  const params = {
    limit: 40,
    sortBy: query?.sortBy ? query?.sortBy : 'catOrder',
    sortType: query?.sortType ? query?.sortType : 'asc',
    catDisplay: true,
    ...query,
    ...{ catId: categoryDetail?._id || '' },
  }
  const [menus, banner, quickMenu, pageDetail, bottomMenu, keywords, regions] =
    await Promise.all([
      getMenus(),
      getBannerSSR(),
      getQuickMenu(),
      getPageDetailSSR(path, params),
      getBottomMenu(),
      getKeyword(),
      getSaleRegion(),
    ])
  if (!pageDetail || !pageDetail?.data) {
    return {
      notFound: true,
    }
  }

  return {
    props: {
      menus,
      banner,
      language,
      messages,
      quickMenu,
      bottomMenu,
      pageDetail,
      pageType: getPageTypeFromPath(path),
      categoryDetail: categoryDetail || null,
      hideMenu: hideMenu || null,
      keywords,
      regions,
      token: token || null,
    },
  }
}
